import dayjs from 'dayjs';

var formatDate = function formatDate(dateString) {
  return dayjs(dateString).isValid() ? dayjs(dateString).format('DD/MM/YY') : null;
};

export default formatDate;